import { render, staticRenderFns } from "./outboundShipments.vue?vue&type=template&id=4e32e848"
import script from "./outboundShipments.vue?vue&type=script&lang=js"
export * from "./outboundShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports